// extracted by mini-css-extract-plugin
export default {"control":"control_control__eHjRU","button":"control_button__INdu9"};